import { instrumentModuleGetter } from "next/dist/server/app-render/module-loading/instrument-module-getter";
const __TURBOPACK__icon__$23$0__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"METADATA_0"));
const __TURBOPACK__not$2d$found__$23$1__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_1"));
const __TURBOPACK__forbidden__$23$2__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_2"));
const __TURBOPACK__unauthorized__$23$3__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_3"));
const __TURBOPACK__global$2d$error__$23$4__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_4"));
const __TURBOPACK__layout__$23$5__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_5"));
const __TURBOPACK__page__$23$6__ = instrumentModuleGetter(() => require(/*turbopackChunkingType: shared*/"MODULE_6"));
import { createAppPageEntrypoint } from "next/dist/esm/build/templates/app-page-runtime";
import { interopDefault } from "next/dist/esm/server/app-render/interop-default" with {
    'turbopack-transition': 'next-server-utility'
};
const tree = ["", {
"children": ["[lang]", {
"children": ["reset", {
"children": ["__PAGE__", {
}, {
  metadata: {  },  "page": [__TURBOPACK__page__$23$6__, "[project]/apps/web/src/app/[lang]/reset/page.tsx"],
}, []],
}, {
  metadata: {  },}, []],
}, {
  metadata: {  },  "layout": [__TURBOPACK__layout__$23$5__, "[project]/apps/web/src/app/[lang]/layout.tsx"],
}, ["admin","confirm","preferences","robots.txt","sitemap.xml","unsubscribe"]],
}, {
  metadata: {    icon: [
      (async () => {
        const mod = interopDefault(await __TURBOPACK__icon__$23$0__());
        return [{
          url: "/icon.svg" + `?${mod.src.split("/").splice(-1)[0]}`,
          sizes: `any`,
          type: `image/svg+xml`,
        }];
      }),
    ],
  },  "not-found": [__TURBOPACK__not$2d$found__$23$1__, "[project]/node_modules/next/dist/client/components/builtin/not-found.js"],
  "forbidden": [__TURBOPACK__forbidden__$23$2__, "[project]/node_modules/next/dist/client/components/builtin/forbidden.js"],
  "unauthorized": [__TURBOPACK__unauthorized__$23$3__, "[project]/node_modules/next/dist/client/components/builtin/unauthorized.js"],
  "global-error": [__TURBOPACK__global$2d$error__$23$4__, "[project]/node_modules/next/dist/client/components/builtin/global-error.js"],
}, []]
const __next_app_require__ = __turbopack_context__.r.bind(__turbopack_context__)
const __next_app_load_chunk__ = __turbopack_context__.l.bind(__turbopack_context__)
const entrypoint = createAppPageEntrypoint({
    tree,
    page: "/[lang]/reset/page",
    pathname: "/[lang]/reset",
    require: __next_app_require__,
    loadChunk: __next_app_load_chunk__,
    interopDefault
});
export const __next_app__ = entrypoint.__next_app__;
export const routeModule = entrypoint.routeModule;
export const handler = entrypoint.handler;
export * from "next/dist/esm/server/app-render/entry-base" with {
    'turbopack-transition': 'next-server-utility'
};

//# sourceMappingURL=app-page.js.map
